import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { AnalyticsService } from '../../../services/analytics.service';
import { ThemeService } from '../../../services/theme.service';
import { Icon } from '../icon/icon';

@Component({
  imports: [Icon, TranslatePipe],
  selector: 'app-theme-toggle',
  standalone: true,
  styleUrl: './theme-toggle.scss',
  templateUrl: './theme-toggle.html',
})
export class ThemeToggle {
  get theme(): 'dark' | 'light' {
    return this.themeService.theme();
  }

  private analytics = inject(AnalyticsService);
  private themeService = inject(ThemeService);

  toggle(): void {
    this.themeService.toggle();
    this.analytics.trackEvent('theme_change', { theme: this.themeService.theme() });
  }
}
